import type { FC } from "react";
import { useState } from "react";

import { BasicModal } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import { contactUsModalConfig } from "app/pages/sales-intelligence/common-components/ContactUsModal/configs";
import ModalContent from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/ModalContent";
import { GainAccessButton } from "app/pages/sales-intelligence/common-components/GainAccessButton";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledGainAccessBtnWrapper,
    StyledGainAccessContainer,
    StyledGainAccessSubTitle,
    StyledGainAccessTitle,
} from "./styles";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";

type ContactsLockedHookProps = {
    title: string;
    subTitle: string;
    onClick?: () => void;
};

const ContactsLockedHook: FC<ContactsLockedHookProps> = ({ title, subTitle, onClick }) => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);

    const handleOnCLick = () => {
        requestFeature("SI contacts");
        setContactUsModal(true);
        onClick?.();
    };

    return (
        <StyledGainAccessContainer>
            <div>
                <img
                    src={AssetsService.assetUrl("/images/gain-access-lock.svg")}
                    alt="Gain access"
                    width={219}
                />
            </div>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessTitle}
            >
                {title}
            </I18n>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessSubTitle}
            >
                {subTitle}
            </I18n>
            <StyledGainAccessBtnWrapper>
                <GainAccessButton
                    type="trial"
                    onClick={handleOnCLick}
                    data-automation="si.contacts.hook.get-access.button"
                />
            </StyledGainAccessBtnWrapper>
            <BasicModal
                isOpen={contactUsModal}
                closeIconConfig={{ show: true, onClick: () => setContactUsModal(false) }}
                customStyles={contactUsModalConfig}
                onRequestClose={() => setContactUsModal(false)}
            >
                <ModalContent
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                    buttonText={translate("si.modal.get_feature.success.btn.close")}
                    onClick={() => setContactUsModal(false)}
                />
            </BasicModal>
        </StyledGainAccessContainer>
    );
};

export default ContactsLockedHook;
